import React from 'react';
import { useAppDispatch } from 'ducks/hooks';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import Title from 'ui/Typography/Title';
import { useIntl } from 'react-intl';

import { useTestFeature } from 'optimizely/hooks';
import { getSelectedGroupId } from 'ducks/products';
import Box from 'ui/Box';
import { isMobile } from 'utils/platform';
import BackButton from 'components/ProductSidebar/BackButton/BackButton';
import { isAutoFillSheetVisible, setAutofillActive, setAutoFillSheetVisible } from '../AutofillPax';
import AutoFillOptimizeSpacePax from '../widgets/AutoFillOptimizeSpacePax';
import SlideOutMenu from 'components/SlideOutMenu/SlideOutMenu';
import { useBehaviorTracker } from 'contexts/behaviors';

const StyledBackButton = styled(BackButton)`
  width: 56px;
  position: relative;
  left: -20px;
`;

const Menu = styled.div`
  width: ${({ theme }) => theme.layout.sidebarWidth};
  position: absolute;
  right: 0;
  top: 6px;
  bottom: 0;
  z-index: 501;
  height: 100%;
  overflow-x: auto;
`;

const HeaderWrapper = styled.div`
  padding: 1rem ${({ theme }) => theme.space.xxl};
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  z-index: 1;
`;

const AutoFillSheet = () => {
  const dispatch = useAppDispatch();
  const autoFillSheetVisible = useSelector(isAutoFillSheetVisible);
  const { formatMessage } = useIntl();
  const autofillEnabled = useTestFeature('PaxAutofill');
  const selectedGroupId = useSelector(getSelectedGroupId);
  const behaviorTracker = useBehaviorTracker();

  const onClose = () => {
    behaviorTracker
      .withContext({ groupId: selectedGroupId, menuType: 'sheet', widgetId: 'autofill-pax-sheet' })
      .custom(() => {
        dispatch(setAutoFillSheetVisible(false));
        dispatch(setAutofillActive(false));
      });
  };

  return autofillEnabled && autoFillSheetVisible && !isMobile() ? (
    <SlideOutMenu data-testid="cloth-hangers-sheet" trigger={autoFillSheetVisible}>
      <Menu>
        <HeaderWrapper>
          <StyledBackButton onClick={onClose} dataTestId="autofill-sheet-back-button" />
          <Title type={ThemeFontStyleTypeEnum.headingMedium}>
            {formatMessage({ id: 'storageone.autofillPaxLSheetTitle' })}
          </Title>
        </HeaderWrapper>

        <Box margin="xxl" style={{ marginTop: 0 }}>
          <AutoFillOptimizeSpacePax />
        </Box>
      </Menu>
    </SlideOutMenu>
  ) : (
    <></>
  );
};

export default AutoFillSheet;
